/* eslint-disable @typescript-eslint/unbound-method */
import { Component, type OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { map, type Observable } from 'rxjs';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from '../../shared/services/util.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { Router } from '@angular/router';
import { GsIconListComponent } from '../../shared/components/gs-icon-list/gs-icon-list.component';
import { GSIconListBulletModel, GSIconListModel } from '../../shared/components/gs-icon-list/gs-icon-list.model';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
// import { MatRadioModule } from '@angular/material/radio';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from '../../shared/services/storage.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { AuthService } from '../../shared/services/auth.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CmsService } from '../../shared/services/cms.service';
import { Nav } from '../../shared/enums/nav.enum';
import { StorageEnum } from '../../shared/enums/storage.enum';
import { postalCodeValidator } from '../../shared/validators/postalCode.validator';
import { accountNumberValidator } from '../../shared/validators/accountNumber.validator';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { SeoService } from '../../shared/services/seo.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { NotificationsService } from '../../shared/services/notifications.service';
import { NotificationType } from '../../shared/enums/notificationtype.enum';
import { NotificationComponent } from '../../shared/components/notification/notification.component';

@Component({
  selector: 'app-register',
  templateUrl: './account-lookup.component.html',
  styleUrls: ['./account-lookup.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GsIconListComponent,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    NotificationComponent,
  ],
})
export class AccountLookupComponent implements OnInit {
  pageLabels$!: Observable<any>;
  lookupAccountForm!: FormGroup;
  apiError: string = '';
  formErrorMessage: string = '';
  apiErrorMessage: string = '';
  pageName = 'account-lookup';

  constructor(
    private readonly cms: CmsService,
    private readonly auth: AuthService,
    private readonly formBuilder: FormBuilder,
    // eslint-disable-next-line @typescript-eslint/prefer-readonly
    private router: Router,
    private readonly utils: UtilService,
    private readonly storage: StorageService,
    private readonly seoS: SeoService,
    private readonly notifi: NotificationsService,
  ) {}

  ngOnInit(): void {
    this.pageLabels$ = this.cms.getContent('oas-account-lookup', 'Account Lookup').pipe(
      map((data: any) => {
        this.seoS.setSeoTags(data.seo);

        const unmappedListData = data.bulletList.value.data;
        const listData = new GSIconListModel();
        listData.Header = unmappedListData.header;
        listData.Subheader = unmappedListData.subheader;

        const bulletList: GSIconListBulletModel[] = [];
        unmappedListData?.bulletList?.forEach((bullet: any) => {
          const bulletObj = new GSIconListBulletModel();
          bulletObj.BulletText = bullet.bullet.bulletText;
          bulletObj.BulletTitle = bullet.bullet.bulletTitle;
          bulletObj.IconPath = bullet.bullet.iconPath;
          bulletObj.IconAltText = bullet.bullet.iconAltText;
          bulletObj.ShowBullet = bullet.bullet.showBullet;

          bulletList.push(bulletObj);
        });

        listData.BulletList = bulletList;

        const newDataObj = JSON.parse(JSON.stringify(data));
        newDataObj.accountBenefitsList = listData;
        this.apiError = data.apiErrorText;
        return newDataObj;
      }),
    );
    // Initialize the form group with reactive validators
    this.lookupAccountForm = this.formBuilder.group({
      accountNumber: ['', [Validators.required, Validators.minLength(10), accountNumberValidator()]],
      postalCode: ['', [Validators.required, Validators.minLength(5), postalCodeValidator()]],
    });
    this.utils.hideSpinner();
  }

  get accountNumber(): FormControl {
    return this.lookupAccountForm.get('accountNumber') as FormControl;
  }

  get postalCode(): FormControl {
    return this.lookupAccountForm.get('postalCode') as FormControl;
  }

  onSubmit(): void {
    this.formErrorMessage = '';
    this.apiErrorMessage = '';
    if (this.lookupAccountForm.valid) {
      this.utils.showSpinner();

      this.auth.lookupAccount(this.accountNumber.value, this.postalCode.value).subscribe({
        error: (e) => {
          this.apiErrorMessage = this.apiError;
          this.showAPIErrorLabel(this.apiErrorMessage);
          this.utils.hideSpinner();
        },
        next: (data: any) => {
          this.storage.setSession(StorageEnum.AccountLookUp, data);
          void this.router.navigateByUrl(Nav.OneTimePayment);
        },
      });
    } else {
      // Mark all controls as touched to trigger validation messages
      this.lookupAccountForm.markAllAsTouched();
      this.showFormErrorLabel();
    }
  }

  showFormErrorLabel(): void {
    this.formErrorMessage = this.storage.getSession(StorageEnum.GlobalVars).formError;
    if (this.formErrorMessage && this.formErrorMessage !== '') {
      this.notifi.clearAllNotifications(this.pageName);
      this.notifi.addNotification(this.formErrorMessage, NotificationType.Error, this.pageName);
    }
  }

  showAPIErrorLabel(errMsg: string): void {
    this.apiError = errMsg;
    if (this.apiError && this.apiError !== '') {
      this.notifi.clearAllNotifications(this.pageName);
      this.notifi.addNotification(this.apiError, NotificationType.Error, this.pageName);
    }
  }

  async goToLogin(): Promise<void> {
    await this.router.navigateByUrl(Nav.Login);
  }

  logDebug(data: any): void {
    this.utils.consoleGroup('Login icon-list Debug Data', data);
  }
}
